import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./tenderPopup.scss";

const TENDER_DOCUMENT_URL = "https://calicutdefence.com/rfpdocuments.zip";

export default function TenderPopup() {
  const [show, setShow] = useState(true);

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      dialogClassName="tender-popup"
    >
      <Modal.Header closeButton>
        <Modal.Title>ടെൻഡർ ഡോക്യുമെന്റ്</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Calicut Defence Trust and Care</strong>-ന്റെ നിർദ്ദിഷ്ട ഓഫീസ്
          കെട്ടിടത്തിന്റെ{" "}
          <strong>Phase 1 – Foundation & Framework Construction Work</strong>{" "}
          സംബന്ധിച്ച ടെൻഡർ രേഖകൾ ഇവിടെ ലഭ്യമാണ്.
        </p>
        <p>
          ടെൻഡർ നിബന്ധനകൾ, Scope of Work, Technical Specifications, BOQ,
          Drawings, Draft Agreement, മറ്റ് അനുബന്ധ രേഖകൾ എന്നിവ ഉൾപ്പെടുന്ന{" "}
          <strong>പൂർണ്ണ ടെൻഡർ ഡോക്യുമെന്റ്</strong> ഡൗൺലോഡ് ചെയ്ത് വിശദമായി
          പരിശോധിക്കുക.
        </p>
        <a
          className="tender-download-btn"
          href={TENDER_DOCUMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          📥 Download Tender Document
        </a>
      </Modal.Body>
    </Modal>
  );
}
